import React, { Component } from "react";
import { Dropdown, Button, Modal, Spinner } from "react-bootstrap";
import "../../App.css";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
import Apiurl from "../../Constant/baseUrl";
import axios from "axios";
import Exceptionservice from "../../Services/exception";
import Validationinputonlynumber from "../../Constant/validation";
const ls = new SecureLS();
class Navbar extends Component {
  constructor() {
    super();
    this.state = {
      adminbalance: "",
      treeBalance: "",
      cardBalnce: "",
      totalbalance: "",
      escrowBalance: "",
      formModal: false,
      disabledaddmoneybtn: true,
      addmoneyvalue: "",
      transnumbervalue: "",
      remarkvalue: "",
      logoutmoadalopen: false,
      addmoneyBtnloading: false,
      balanceNotiDiv: "none",
      BalanbarShow: true,
      updateBalanceshow: false,
      AddmoneyShow: false,
      updateBalanceLoading: false,
    };
    this.getBaseUrl = new Apiurl();
    this.getExceptionservice = new Exceptionservice();
    this.getValidationinputonlynumber = new Validationinputonlynumber();
  }
  toggleOffcanvas() {
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  }
  closeModalhandler = () => {
    this.setState({ formModal: false });
  };
  logoutcloseModalhandler = () => {
    this.setState({ logoutmoadalopen: false });
  };
  updatebalanceHandler = () => {
    console.log("Update card is handed!");
    var ls = new SecureLS();
    // let uuid = ls.get("key1").uuid;
    let jwttoken = ls.get("key1").jwtToken;
    this.setState({ updateBalanceLoading: true });
    axios({
      method: "GET",
      url: `${this.getBaseUrl.ApiBAseURL}/api/view/wallet/balance`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + jwttoken,
        "X-Frame-Options": "sameorigin",
      },
    })
      .then((response) => {
        // var ls = new SecureLS();
        let res = response.data;

        if (res.successCode === "API_SUCCESS") {
          Swal.fire("Balance Updated Successfully");
          this.setState({ updateBalanceLoading: false });
          if (res.exception === "WALLET_NOT_EXIST") {
            this.setState({
              totalbalance: 0,
              adminbalance: 0,
              treeBalance: 0,
              cardBalnce: 0,
              balanceNotiDiv: "block",
            });
          } else {
            let balance = res.responseData;

            this.setState({
              totalbalance: balance.myBalance,
              treeBalance: balance.treeBalance,
              cardBalnce: balance.cardBalance,
              escrowBalance: balance.escrowAccountBalance,
            });
            if (balance.adminBalance < 10000) {
              this.setState({ balanceNotiDiv: "none" });
            } else {
              this.setState({ balanceNotiDiv: "none" });
            }
          }
        } else {
          this.getExceptionservice.handlerOtherExcetion(
            response.data.exception
          );
        }
      })
      .catch((error) => {
        // console.log(error);
        this.getExceptionservice.handleNetworkException(error);
      });
  };
  componentDidMount() {
    var ls = new SecureLS();
    const jwtToken = ls.get("key1")?.jwtToken;
    // this.balanceinquery();
    if (jwtToken) {
      this.balanceinquery(jwtToken);
    }

    if (ls.get("key1").userType === "ADMIN") {
      ls.get("key1").adminAuthorisationDto.map((v) => {
        if (v.adminAuthorisation === "UPDATE_BALANCE") {
          return v.adminRights.includes("VIEW") === true
            ? this.setState({ updateBalanceshow: true })
            : this.setState({ updateBalanceshow: false });
        }
      });
    }
    if (ls.get("key1").userType === "ADMIN") {
      ls.get("key1").adminAuthorisationDto.map((v) => {
        if (v.adminAuthorisation === "ADD_MONEY") {
          return v.adminRights.includes("VIEW") === true
            ? this.setState({ AddmoneyShow: true })
            : this.setState({ AddmoneyShow: false });
        }
      });
    }
  }
  addmoneyInputHandler = (e) => {
    if (e.target.value === "") {
      this.setState({
        disabledaddmoneybtn: true,
        addmoneyvalue: e.target.value,
      });
    } else
      this.setState({
        disabledaddmoneybtn: false,
        addmoneyvalue: e.target.value,
      });
  };
  transnumberHandler = (e) => {
    if (e.target.value === "") {
      this.setState({
        disabledaddmoneybtn: true,
        transnumbervalue: e.target.value,
      });
    } else
      this.setState({
        disabledaddmoneybtn: false,
        transnumbervalue: e.target.value,
      });
  };
  remarkHandler = (e) => {
    if (e.target.value === "") {
      this.setState({ disabledaddmoneybtn: true, remarkvalue: e.target.value });
    } else
      this.setState({
        disabledaddmoneybtn: false,
        remarkvalue: e.target.value,
      });
  };
  addmoneysubmitHandler = () => {
    if (this.state.addmoneyvalue <= 0) {
      Swal.fire({ text: "Amount should be greater than Zero" });
    } else if (this.state.transnumbervalue === "") {
      Swal.fire({ text: "Transaction Number can not be empty" });
    } else {
      this.setState({ disabledaddmoneybtn: true, addmoneyBtnloading: true });
      var ls = new SecureLS();
      let jwttoken = ls.get("key1").jwtToken;
      let useruuid = ls.get("key1").uuid;
      // let sessionToken = ls.get("key1").sessionToken;
      let data = {
        uuidBy: useruuid,
        balance: this.state.addmoneyvalue,
        transactionNo: this.state.transnumbervalue,
        remarks: this.state.remarkvalue,
      };

      axios({
        method: "POST",
        url: `${this.getBaseUrl.ApiBAseURL}/api/money/add`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + jwttoken,
          "X-Frame-Options": "sameorigin",
        },
        data: data,
      })
        .then((response) => {
          // console.log("response", response.data);
          let res = response.data;
          if (res.successCode === "API_SUCCESS") {
            Swal.fire({
              title: "Balance Added Succesfully",
              type: "Success",
            }).then(() => {
              this.balanceinquery();
              this.setState({
                formModal: false,
                disabledaddmoneybtn: false,
                addmoneyBtnloading: false,
              });
            });
          } else if (res.exception === "ADD_BALANCE_IN_WALLET") {
            Swal.fire({
              title: "Sorry",
              text: "Balance should be greater then Zero",
              icon: "warning",
            }).then(() => {
              this.setState({
                disabledaddmoneybtn: false,
                addmoneyBtnloading: false,
              });
            });
          } else if (res.exception === "TRANSACTION_NUMBER_ALREADY_EXIST") {
            Swal.fire({
              title: "Sorry",
              text: "Transaction number already exist",
              icon: "warning",
            }).then(() => {
              this.setState({
                disabledaddmoneybtn: false,
                addmoneyBtnloading: false,
              });
            });
          } else if (res.exception === "FIELD_CAN_NOT_BE_EMPTY") {
            Swal.fire({
              title: "Field can not be empty",
              text: "Kindly fill all details",
              type: "warning",
            }).then(() => {
              this.setState({
                disabledaddmoneybtn: false,
                addmoneyBtnloading: false,
              });
            });
          } else {
            this.getExceptionservice.handlerOtherExcetion(
              response.data.exception
            );
          }
        })
        .catch((error) => {
          // console.log(error);
          this.getExceptionservice.handleNetworkException(error);
        });
    }
  };
  addmoneyBtnHandler = () => {
    // this.setState({ formModal: true });
    let userType = ls.get("key1").userType;
    userType === "ADMIN"
      ? this.setState({ formModal: true })
      : this.props.history.push("/retailerrequest");
  };
  balanceinquery = (jwtToken) => {
    // var ls = new SecureLS();
    // let uuid = ls.get("key1").uuid;

    axios({
      method: "GET",
      url: `${this.getBaseUrl.ApiBAseURL}/api/view/wallet/balance`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + jwtToken,
        "X-Frame-Options": "sameorigin",
      },
    })
      .then((response) => {
        // var ls = new SecureLS();
        let res = response.data;
        // console.log("aaaaaaaaaaa", res);
        if (res.exception === "WALLET_NOT_EXIST") {
          this.setState({
            totalbalance: 0,
            adminbalance: 0,
            treeBalance: 0,
            cardBalnce: 0,
            escrowBalance: 0,
            balanceNotiDiv: "block",
          });
        } else if (res.responseData) {
          let balance = res.responseData;
          this.setState({
            totalbalance: balance.myBalance,
            treeBalance: balance.treeBalance,
            cardBalnce: balance.cardBalance,
            escrowBalance: balance.escrowAccountBalance,
          });
          if (balance.adminBalance < 10000) {
            this.setState({ balanceNotiDiv: "none" });
          } else {
            this.setState({ balanceNotiDiv: "none" });
          }
        }
        // else {
        //   this.getExceptionservice.handlerOtherExcetion(
        //     response.data.exception
        //   );
        // }
      })
      .catch((error) => {
        this.getExceptionservice.handleNetworkException(error);
      });
  };
  changepasswprd = () => {
    this.props.history.push("/changepassword");
  };
  profilePage = () => {
    this.props.history.push("/profile");
  };
  logoutHandler = () => {
    var ls = new SecureLS();
    let jwttoken = ls.get("key1").jwtToken;
    let useruuid = ls.get("key1").uuid;
    let sessionToken = ls.get("key1").sessionToken;
    let data = {
      uuid: useruuid,
      sessionToken: sessionToken,
    };
    axios({
      method: "PUT",
      url: `${this.getBaseUrl.ApiBAseURL}/api/admin/logout`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + jwttoken,
        "X-Frame-Options": "sameorigin",
      },
      data: data,
    })
      .then((response) => {
        // console.log("response", response.data);
        let res = response.data;
        if (res.successCode === "API_SUCCESS") {
          this.props.history.push("/");
          ls.removeAll(); // remove all keys
        } else if (res.exception === "SESSION_NOT_FOUND") {
          Swal.fire({
            title: "Sorry",
            text: "Session not find",
            type: "error",
            button: "OK",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            this.props.history.push("/");
          });
        } else {
          this.props.history.push("/");
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  };
  openlogoutmodalHandler = () => {
    this.setState({ logoutmoadalopen: true });
  };

  getUserName = () => {
    let userName = ls.get("key1").firstName;
    if (userName) {
      return userName.charAt(0).toUpperCase() + userName.slice(1);
    }
  };

  render() {
    const { updateBalanceLoading } = this.state;
    return (
      <nav className="navbar col-lg-12 col-12 p-lg-0 fixed-top d-flex flex-row">
        <div
          className="navbar-menu-wrapper d-flex align-items-center justify-content-between"
          style={{ background: "#F2F2F2 0% 0% no-repeat padding-box" }}
        >
          <a
            className="navbar-brand brand-logo-mini align-self-center d-lg-none"
            href="!#"
            onClick={(evt) => evt.preventDefault()}
          >
            <img
              src={require("../../assets/images/logo.png")}
              alt="logo"
              style={{ width: 80 }}
            />
          </a>
          <button
            className="navbar-toggler navbar-toggler align-self-center"
            type="button"
            onClick={() => document.body.classList.toggle("sidebar-icon-only")}
          >
            <img src={require("../../assets/images/menuicon.png")} alt="menu" />
          </button>

          <ul className="mobileshowbalance navbar-nav navbar-nav-left header-links">
            {
              <li style={{ paddingTop: 23, fontSize: 13, color: "#000" }}>
                {ls.get("key1").userType === "ADMIN" && (
                  <>
                    Card balance: ({this.state.cardBalnce}), Tree balance: (
                    {this.state.treeBalance}), Escrow Balance : (
                    {this.state.escrowBalance !== null
                      ? this.state.escrowBalance
                      : ""}
                    )
                  </>
                )}

                {ls.get("key1").userType === "RETAILER" && (
                  <>My balance:({this.state.totalbalance})</>
                  //Card balance: ( {this.state.cardBalnce})
                )}
              </li>
            }
            <li className="nav-item  nav-profile border-0 pl-4">
              <Button
                variant="primary"
                onClick={this.updatebalanceHandler}
                className="refershbutton"
              >
                {updateBalanceLoading && (
                  <Spinner
                    size="sm"
                    animation="border"
                    variant="primary"
                    style={{ marginRight: 10 }}
                  />
                )}
                {!updateBalanceLoading && (
                  <span>
                    <i className="mdi mdi-autorenew"></i>
                  </span>
                )}{" "}
              </Button>
            </li>
            {/* {ls.get("key1").userType === "ADMIN" ? null : (
              <li className="nav-item  nav-profile border-0 pl-4">
                <Button
                  variant="primary"
                  onClick={this.updatebalanceHandler}
                  className="refershbutton"
                >
                  {updateBalanceLoading && (
                    <Spinner
                      size="sm"
                      animation="border"
                      variant="primary"
                      style={{ marginRight: 10 }}
                    />
                  )}
                  {!updateBalanceLoading && (
                    <span>
                      <i className="mdi mdi-autorenew"></i>
                    </span>
                  )}{" "}
                </Button>
              </li>
            )} */}
            {/* <li className="" style={{ marginTop: 12 }}>
              <Button
                variant="primary"
                style={{ fontWeight: "bold", backgroundColor: "none" }}
                onClick={this.updatebalanceHandler}
                className="mobileheaderbutton"
              >
                {updateBalanceLoading && (
                  <Spinner
                    size="sm"
                    animation="border"
                    variant="primary"
                    style={{ marginRight: 10 }}
                  />
                )}
                {updateBalanceLoading && <span>Loading..</span>}
                {!updateBalanceLoading && (
                  <span>
                    <i class="mdi mdi-autorenew"></i>
                  </span>
                )}{" "}
              </Button>
            </li> */}
          </ul>
          <ul className="navbar-nav navbar-nav-right ml-lg-auto">
            <li className="nav-item  nav-profile border-0"></li>

            {/* {this.state.updateBalanceshow === false ? null : (
              <li className="" style={{ marginTop: 12 }}>
                <Button
                  variant="primary"
                  style={{ fontWeight: "bold", backgroundColor: "none" }}
                  onClick={this.updatebalanceHandler}
                  className="mobileheaderbutton"
                >
                  {updateBalanceLoading && (
                    <Spinner
                      size="sm"
                      animation="border"
                      variant="primary"
                      style={{ marginRight: 10 }}
                    />
                  )}
                  {updateBalanceLoading && <span>Loading..</span>}
                  {!updateBalanceLoading && (
                    <span>
                      <i class="mdi mdi-autorenew"></i>
                    </span>
                  )}{" "}
                </Button>
              </li>
            )} */}

            <li className="nav-item  nav-profile border-0">
              <div className="profileimgWrap">
                <img
                  src={require("../../assets/images/UserProfileIcon.png")}
                  alt=""
                />
              </div>

              <Dropdown alignRight>
                <Dropdown.Toggle className="nav-link count-indicator bg-transparent pdrop">
                  <span className="profile-text" style={{ fontWeight: "bold" }}>
                    {this.getUserName()}
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="preview-list navbar-dropdown pb-3">
                  <Dropdown.Item
                    className="dropdown-item p-0 preview-item d-flex align-items-center border-bottom"
                    href="!#"
                    onClick={(evt) => evt.preventDefault()}
                  ></Dropdown.Item>
                  <Dropdown.Item
                    className="dropdown-item preview-item d-flex align-items-center border-0"
                    onClick={this.profilePage}
                  >
                    Profile
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="dropdown-item preview-item d-flex align-items-center border-0"
                    onClick={this.changepasswprd}
                  >
                    Change Password
                  </Dropdown.Item>
                  <Dropdown.Item
                    className="dropdown-item preview-item d-flex align-items-center border-0"
                    onClick={this.openlogoutmodalHandler}
                  >
                    Log Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <Modal
                className="navbarmodal modal-dialog-centered"
                size="md"
                show={this.state.logoutmoadalopen}
                style={{}}
                aria-labelledby="example-modal-sizes-title-lg"
              >
                <Modal.Body style={{ width: 400 }}>
                  <div style={{ textAlign: "center" }}>
                    <p style={{ fontWeight: "bold" }}>Do you want to logout?</p>
                    <p>You will be returned to the login screen</p>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    color="secondary"
                    data-dismiss="modal"
                    type="button"
                    onClick={this.logoutcloseModalhandler}
                  >
                    Close
                  </Button>
                  <Button
                    color="primary"
                    type="button"
                    onClick={this.logoutHandler}
                  >
                    OK
                  </Button>
                </Modal.Footer>
              </Modal>
            </li>
          </ul>

          <button
            className="navbar-toggler navbar-toggler-right d-lg-none align-self-center"
            type="button"
            onClick={this.toggleOffcanvas}
          >
            <span className="mdi mdi-menu"></span>
          </button>
        </div>
        <div
          style={{
            marginLeft: 25,
            color: "red",
            display: this.state.balanceNotiDiv,
          }}
        >
          Your balance is low, kindly add balance
        </div>
        <div className="divmobilebalaceshow">
          {ls.get("key1").userType === "ADMIN" && (
            <>
              <p className="mobilebalaceshow">
                Card balance: ({this.state.cardBalnce}), Tree balance: (
                {this.state.treeBalance}), Escrow Balance : (
                {this.state.escrowBalance !== null
                  ? this.state.escrowBalance
                  : ""}
                )
              </p>
            </>
          )}
          {ls.get("key1").userType === "RETAILER" && (
            <>
              <p className="mobilebalaceshow">
                My balance:({this.state.totalbalance}), Card balance: (
                {this.state.cardBalnce})
              </p>
            </>
          )}
          <div style={{ paddingLeft: "20px" }}>
            <Button
              variant="primary"
              style={{ fontWeight: "bold", backgroundColor: "none" }}
              onClick={this.updatebalanceHandler}
            >
              {updateBalanceLoading && (
                <Spinner
                  size="sm"
                  animation="border"
                  variant="primary"
                  style={{ marginRight: 10 }}
                />
              )}
              {updateBalanceLoading && <span>Loading..</span>}
              {!updateBalanceLoading && (
                <span>
                  <i className="mdi mdi-autorenew"></i>
                </span>
              )}
            </Button>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
